module.exports = __webpack_public_path__ + "static/media/008.ecc0d0b1.jpg";